import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type SetHashOptions = {
  replace?: boolean;
};

export const useUrlHash = () => {
  const { hash, pathname, search } = useLocation();
  const history = useHistory();

  const value = useMemo(
    () => (hash ? hash.replace(/^#/, '') : undefined),
    [hash],
  );

  const setHash = useCallback(
    (nextHash?: string, options?: SetHashOptions) => {
      const newHash = nextHash ? `#${nextHash}` : '';

      if (options?.replace) {
        history.replace({
          pathname,
          search,
          hash: newHash,
        });
      } else {
        history.push({
          pathname,
          search,
          hash: newHash,
        });
      }
    },
    [history, pathname, search],
  );

  return {
    hash: value,
    setHash,
  };
};
